<!-- 单校多科校级报告 -->
<template>
  <div class="wrapper">
    <!--  各班总分基础指标分析-->
    <div class="card">
      <div class="header-wrap">
        <h3 style="width:35%">{{ gradeName }}各班基础指标对比分析</h3>
        <div class="header-center">
          <el-button-group>
            <el-button type="text" :class="basicIndicatorsHistogram?'active':''" size="medium" @click="basicIndicatorsHistogram = true">柱状图</el-button>
            <el-button type="text" :class="basicIndicatorsHistogram?'':'active'" size="medium" @click="basicIndicatorsHistogram = false">表格</el-button>
          </el-button-group>
        </div>
        <div class="header-right">
          <multi-select v-if="classLists.length>0" ref="multiSelect" :items="classLists" @change="handleCheckedSchoolClassChange" :default-all="false" placeholder="请选择班级" class="basic-select"></multi-select>

          <el-select v-show="!basicIndicatorsHistogram" v-model="checkedBasicIndicators" multiple collapse-tags style="width:180px" placeholder="指标" @change="handleCheckedBasicIndicatorsChange">
            <el-option v-for="item in basicIndicatorsTarget" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>

          <span class="text" v-loading="exportLoading" @click="exportBasicIndicators('basicIndicators')">导出
            <img src="~images/export-icon.svg" />
          </span>
        </div>
      </div>

      <div class="card-content">
        <div v-show="basicIndicatorsHistogram">
          <div style="display: flex; justify-content: center;">
            <div class="title-bg">
              <span v-for="(target,index) in  basicIndicatorsHistogramTarget" :class="target.show?'active':''" :key="'target-'+index" @click="changeTarget(target)" :title="target.name">{{target.name}}</span>
            </div>
          </div>

          <div id="basicIndicators" v-show="compareImgData.length > 0" v-loading="basicIndicatorsLoading"></div>
          <div v-show="compareImgData.length <= 0" style="text-align: center;height: 150px;padding-top: 70px;color:#999">
            <img src="~images/nodata.png" alt width="100" />
            <p style="margin-bottom: 20px">暂无数据</p>
          </div>
        </div>

        <div v-show="!basicIndicatorsHistogram" class="inner">
          <div class="table-wrap table-mini-th">
            <el-table :data="compareDataPart" size="mini" v-loading="quotaLoading" border @sort-change="sortMethod3" style="width: 100%" :row-class-name="tableRowClassName" max-height="600px">
              <el-table-column width="60" prop="className" align="center" label="班级" fixed></el-table-column>
              <el-table-column width="66" prop="statisticalNum" align="center" label="分析人数"></el-table-column>
              <el-table-column width="66" prop="missNum" align="center" label="缺考人数"></el-table-column>

              <template v-for="item in basicIndicatorsTargetList">
                <el-table-column v-if="item.show" :prop="item.value" align="center" sortable="custom" :label="item.name">
                  <el-table-column v-if="item.child&&item.child.length>0" v-for="target in item.child" :prop="target.value" align="center" :label="target.name" :key="item.value+'-' + target.value">
                    <template slot-scope="scope">
                      <span>{{ scope.row[target.value] }}{{ target.suffix }}</span>
                    </template>
                  </el-table-column>
                  <template v-else slot-scope="scope">
                    <span>{{ scope.row[item.value] }}</span>
                  </template>
                </el-table-column>
              </template>

            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 各科基础指标分析 -->
    <div class="card">
      <div class="header-wrap">
        <h3>{{ gradeName }}各科基础指标分析</h3>

        <div class="header-right">
          <!-- 指标 -->
          <el-select v-model="checkedSubBasicIndicators" multiple collapse-tags style="width:180px" placeholder="指标" @change="handleCheckedSubBasicIndicatorsChange">
            <el-option v-for="item in basicSubIndicatorsTarget" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>

          <span class="text" v-loading="exportSubLoading" @click="exportBasicIndicators('')">导出
            <img src="~images/export-icon.svg" />
          </span>
        </div>
      </div>

      <div class="card-table table-mini-th">
        <el-table :data="subjectScoreList" size="mini" v-loading="subjectScoreLoading" border @sort-change="sortMethod" style="width: 100%" :row-class-name="tableRowClassName" max-height="600px">
          <el-table-column prop="subjectName" align="center" label="科目"></el-table-column>
          <el-table-column prop="statisticalNum" align="center" label="分析人数"></el-table-column>
          <el-table-column prop="missNum" align="center" label="缺考人数"></el-table-column>

          <el-table-column v-for="(item,index) in basicSubIndicatorsTargetList" :prop="item.value" align="center" sortable="custom" :label="item.name" :key="'basic-sub-'+index">
            <el-table-column v-for="target in item.child" :prop="target.value" align="center" :label="target.name" :key="item.value+'-' + target.value">
              <template slot-scope=" scope">
                <span>{{ scope.row[target.value] }}{{ target.suffix }}</span>
              </template>
            </el-table-column>
          </el-table-column>

        </el-table>
      </div>
    </div>

    <!-- 总体多科四分位数分析 -->
    <div class="card">
      <h3>
        {{ gradeName }}总体多科四分位数分析
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content" style="line-height:20px;width:400px">四分位数是指处在25%位置上的数值（称为下四分位数q1）和处在75%位置上的数值（称为上四分位数q3）</div>
          <img style="height:14px;vertical-align: middle;margin-left: 5px;margin-top: -3px" src="~images/explain.png" alt />
        </el-tooltip>
      </h3>

      <div id="fourSectionAnalysis" v-loading="fourSectionAnalysisLoading"></div>
    </div>
    <!-- 本场优劣势学科分析 -->
    <div class="card advantage">
      <div class="head-top">
        <h3>{{ gradeName }}本场优劣势学科分析</h3>
        <div class="select-round">
          <el-select v-model="classId" size="mini">
            <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="card-three" v-loading="subjectLoading">
        <div style="flex: 1">
          <div style="margin: 8px 0;">
            <el-button-group>
              <el-button type="primary" plain>优势学科</el-button>
              <el-button type="primary" style="width: 100px">{{ advantage||'暂无' }}&nbsp;</el-button>
            </el-button-group>
          </div>
          <div style="margin: 8px 0;">
            <el-button-group>
              <el-button type="danger" plain>劣势学科</el-button>
              <el-button type="danger" style="width: 100px">{{ inferiority||'暂无' }}&nbsp;</el-button>
            </el-button-group>
          </div>
          <div class="tip-wrapper">
            <img src="~images/tip.png" width="20" height="20" />
            <div class="tip">
              <p>雷达图占比例越多代表该学科越占优势</p>
              <p>对比每个数据大小可以对比出每个学科的优劣情况</p>
            </div>
          </div>
        </div>

        <div id="subjectRadar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { GradeStability } from "@/api/exam/report";
import echarts from "echarts/lib/echarts";
import line from "echarts/lib/chart/line";
import radar from "echarts/lib/chart/radar";
import boxplot from "echarts/lib/chart/boxplot";
import { mapGetters } from "vuex";
import { echartLine, myEchartRadar, multipleYEchartBar, exportChart } from "@/utils/echart";
import util from "@/v2/utils/util";
import { baseApi, reportApi } from '@/v2/utils/api'
import MultiSelect from '@/v2/views/components/MultiSelect.vue';

export default {
  props: ["gradeName", "examInfo", "classList", 'branch'],

  data () {
    return {
      fourSectionAnalysisLoading: false,
      classStabilityData: [],
      examId: this.$route.params.id,

      subjectScoreLoading: false, // 各科基础指标
      subjectScoreList: [],
      subjectScoreList_copy: [],
      subjectLoading: false,

      classRankingData: [], //优劣势学科图形数据
      advantage: "", // 优势学科
      inferiority: "", // 劣势学科
      classId: "",
      isShowMedian: false, // 是否显示中位数

      basicIndicatorsHistogram: false,
      indicatorsVisible: false,
      checkedBasicIndicators: [],
      basicIndicatorsTargetBase: [
        {
          "name": "最高分",
          "show": true,
          "value": "maxScore"
        },
        {
          "name": "最低分",
          "show": true,
          "value": "minScore"
        },
        {
          "name": "中位数",
          "show": true,
          "value": "median"
        },
        {
          "name": "平均分", // 平均得分率
          "show": true,
          "value": "averageScore"
        },
        {
          "name": "级差",
          "show": false,
          "value": "fromAverage" //如果选了极差字段，请添加当前红色json
        }
      ],
      basicIndicatorsTarget: [],
      exportLoading: false,
      basicIndicatorsHistogram: true,
      schoolClassVisible: false,
      isIndeterminate: false,
      checkAll: [],
      checkedSchoolClasses: [],
      compareData: [], // 基础指标对比分析数据
      quotaList: [],
      compareTableGradeData: {},
      basicIndicatorsHistogramTarget: [],
      compareDataPart: [],
      quotaLoading: false,
      compareImgData: [],
      basicIndicatorsLoading: false,
      classLists: [],
      checkTaskCount: 0,
      checkSubTaskCount: 0,
      subIndicatorsVisible: false,
      checkedSubBasicIndicators: [],
      exportSubLoading: false,
      basicSubIndicatorsTarget: [],
      subIndicatorsSortInfo: {},
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    basicIndicatorsTargetList () {
      if (!this.basicIndicatorsTarget) {
        return []
      }
      const ranking = this.basicIndicatorsTarget.find(s => s.name === '排名');
      const fromAverage = this.basicIndicatorsTarget.find(s => s.name === '级差');
      const list = this.basicIndicatorsTarget.filter(s => ['排名', '级差'].indexOf(s.name) < 0);
      const targetList = []
      list.forEach(item => {
        const target = { ...item, child: [] }
        //  一分：平均分
        if (['average'].some(s => item.value.includes(s))) {
          const childList = [{
            name: '平均分',
            value: 'averageScore',
            suffix: '',
          }, {
            name: '平均得分率',
            value: 'averageRate',
            suffix: '',
          }]
          if (ranking && ranking.show) {
            childList.push({
              name: '排名',
              value: 'averageRanking',
              suffix: '',
            })
          }
          target.child.push(...childList)
        }
        else if (['wonder', 'excel', 'good', 'pass', 'tired', 'feeble'].some(s => item.value.includes(s))) {
          const key = item.value.replace('Rate', '')

          const childList = [{
            name: '比率',
            value: key + 'Rate',
            suffix: '%',
          }, {
            name: '人数',
            value: key + 'Num',
            suffix: '人',
          }]
          if (ranking && ranking.show) {
            childList.push({
              name: '排名',
              value: key + 'RateRanking',
              suffix: '',
            })
          }
          if (fromAverage && fromAverage.show) {
            childList.push({
              name: '级差',
              value: item.value + 'FromAverage',
              suffix: '',
            })
          }
          target.child.push(...childList)
        }
        targetList.push(target)
      })
      return targetList
    },
    basicSubIndicatorsTargetList () {
      if (!this.basicSubIndicatorsTarget) {
        return []
      }
      const list = this.basicSubIndicatorsTarget.filter(s => ['排名', '级差'].indexOf(s.name) < 0 && s.show);
      const targetList = []
      list.forEach(item => {
        const target = { ...item, child: [] }
        //  一分：平均分
        if (['average'].some(s => item.value.includes(s))) {
          const childList = [{
            name: '平均分',
            value: 'averageScore',
            suffix: '',
          }, {
            name: '平均得分率',
            value: 'averageRate',
            suffix: '',
          }]
          target.child.push(...childList)
        }
        else if (['wonder', 'excel', 'good', 'pass', 'tired', 'feeble'].some(s => item.value.includes(s))) {
          const key = item.value.replace('Rate', '')

          const childList = [{
            name: '比率',
            value: key + 'Rate',
            suffix: '%',
          }, {
            name: '人数',
            value: key + 'Num',
            suffix: '人',
          }]
          target.child.push(...childList)
        }
        targetList.push(target)
      })
      return targetList
    }
  },

  mounted () {
    this.schoolId = this.userInfo.schoolId;
    this.classId = this.classList.length > 0 ? this.classList[0].id : '';
    this._initFunc();
  },

  methods: {
    async classStability () {
      this.fourSectionAnalysisLoading = true;
      let res = await reportApi.getMultipleGradeStability({
        finalExamId: this.examId,
        schoolId: this.schoolId,
      });
      this.fourSectionAnalysisLoading = false;
      if (res.success) {
        this.classStabilityData = res.body;
        this.drawStability();
      } else {
        this.$message.error(res.message);
      }
    },
    drawStability () {
      let data = this.classStabilityData;
      let xData = data.map(d => d.subjectName);
      let lData = data.map(d => d.examName);
      data = data.map(d => {
        let arr = [];
        arr[0] = d.max;
        arr[1] = d.upper;
        arr[2] = d.middle;
        arr[3] = d.lower;
        arr[4] = d.min;
        return arr;
      });
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: formatter
        },
        grid: {
          left: "10%",
          top: "20%",
          right: "10%",
          bottom: "20%"
        },
        xAxis: {
          type: "category",
          name: "学科",
          data: xData,
          boundaryGap: true,
          nameGap: 30,
          splitLine: {
            show: false
          },
          axisTick: false,
          axisLine: {
            show: false
          },
          nameTextStyle: {
            color: "#71767D"
          },
          axisLabel: {
            textStyle: {
              color: "#71767D"
            }
          }
        },
        yAxis: {
          type: "value",
          name: "分数",
          splitArea: {
            show: false
          },
          axisTick: false,
          axisLine: {
            show: false
          },
          nameTextStyle: {
            color: "#71767D"
          },
          axisLabel: {
            textStyle: {
              color: "#71767D"
            }
          }
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          },
          {
            show: true,
            height: 25,
            type: "slider",
            top: "90%",
            xAxisIndex: [0],
            start: 0,
            end: 20
          }
        ],
        series: [
          {
            name: "",
            type: "boxplot",
            data: data,
            itemStyle: {
              color: "#C8DDFE",
              borderColor: "#478EFF",
              borderWidth: 2
            }
          }
        ]
      };
      let chart = echarts.init(document.getElementById("fourSectionAnalysis"));
      this.$nextTick(() => {
        chart.setOption(option);
      });
      let that = this;
      function formatter (param) {
        param = param[0];
        return [
          lData[param.dataIndex],
          "最大值: " + param.data[1],
          "上四分位数(q3): " + param.data[2],
          "中位数: " + param.data[3],
          "下四分位数(q1): " + param.data[4],
          "最小值: " + param.data[5]
        ].join("<br/>");
      }
    },
    sortMethod ({ prop, order }) {
      this.subIndicatorsSortInfo = {
        name: prop,
        order: order,
      }
      let subjectScoreList = util.deepCopy(this.subjectScoreList_copy)
      const subjectItem = subjectScoreList.find(s => s.subjectName === '学科汇总')
      const list = subjectScoreList.filter(s => s.subjectName !== '学科汇总')
      this.listOrder(list, order, prop)
      this.subjectScoreList = [subjectItem, ...list];
    },
    sortMethod3 ({ prop, order }) {
      this.indicatorsSortInfo = {
        name: prop,
        order: order,
      }
      let compareDataPart = util.deepCopy(this.compareDataPart)
      const gradeItem = compareDataPart.find(s => s.className === '年级')
      const list = compareDataPart.filter(s => s.className !== '年级')
      this.listOrder(list, order, prop)
      this.compareDataPart = [gradeItem, ...list]
    },
    listOrder (list, order, prop) {
      if (order !== 'none') {
        list.sort((a, b) => {
          let valA = parseFloat(a[prop]);
          let valB = parseFloat(b[prop]);
          if (typeof valA === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }
          return order === 'ascending' ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
        })
      }
    },

    _initFunc () {
      this.resetClassList()
      this.initBasicIndicatorsTarget()
      this.getMultipleBasicIndicators();// 基础指标
      this._getGradeMultipleBaseList(); // 基础指标分析
      this._classMultiRanking(); // 优劣势学科分析
      this.classStability();
    },

    // 年级多科基础指标分析
    async _getGradeMultipleBaseList () {
      let params = {
        schoolId: this.schoolId,
        finalExamId: this.examId,
      };
      this.subjectScoreLoading = true;
      let resp = await reportApi.getGradeMultipleBaseList(params);
      this.subjectScoreLoading = false;

      if (resp.success) {
        for (let item of resp.body) {
          item.maxScore = isNaN(item.maxScore) ? '--' : parseFloat(item.maxScore)
          item.minScore = isNaN(item.minScore) ? '--' : parseFloat(item.minScore)
          item.averageScore = isNaN(item.averageScore) ? '--' : parseFloat(item.averageScore)
          item.wonderRate = isNaN(parseFloat(item.wonderRate)) ? '--' : parseFloat(item.wonderRate)
          item.excelRate = isNaN(parseFloat(item.excelRate)) ? '--' : parseFloat(item.excelRate)
          item.goodRate = isNaN(parseFloat(item.goodRate)) ? '--' : parseFloat(item.goodRate)
          item.passRate = isNaN(parseFloat(item.passRate)) ? '--' : parseFloat(item.passRate)
          item.tiredRate = isNaN(parseFloat(item.tiredRate)) ? '--' : parseFloat(item.tiredRate)
          item.feebleRate = isNaN(parseFloat(item.feebleRate)) ? '--' : parseFloat(item.feebleRate)
          item.deviation = isNaN(item.deviation) ? '--' : parseFloat(item.deviation)
        }

        this.subjectScoreList = resp.body;
        this.subjectScoreList_copy = JSON.parse(JSON.stringify(resp.body));
      }
    },

    //查询班级优劣势学科分析
    async _classMultiRanking () {
      this.subjectLoading = true;
      let params = {
        schoolId: this.schoolId,
        classId: this.classId,
        finalExamId: this.examId,
        academicYear: YJ_SCHOOL_STORAGE.getItem("academicYear"),
        branch: this.branch
      };

      let resp = await reportApi.getClassMultiRanking(params);
      const responseData = resp.body || {};
      this.classRankingData = responseData.rows || [];
      this.advantage = responseData.advantage ? responseData.advantage.subjectName : '';
      this.inferiority = responseData.inferiority ? responseData.inferiority.subjectName : '';
      this.subjectLoading = false;
    },
    resetClassList () {
      const classLists = []
      if (Array.isArray(this.classList)) {
        this.classList.forEach(item => {
          classLists.push({
            value: item.id,
            name: item.gradeName + item.className
          })
        })
      }
      this.classLists = classLists
    },
    async initBasicIndicatorsTarget () {
      const targetList = util.deepCopy(this.basicIndicatorsTargetBase)
      const subTargetList = util.deepCopy(this.basicIndicatorsTargetBase.filter(s => s.name != '级差'))
      const list = [{
        "name": "满分",
        "show": true,
        "value": "totalExamScore"
      }, {
        "name": "最高分",
        "show": true,
        "value": "maxScore"
      },
      {
        "name": "最低分",
        "show": true,
        "value": "minScore"
      },
      {
        "name": "平均分",
        "show": true,
        "value": "averageScore"
      }]

      // 获取六率信息
      const res = await baseApi.getSixRateConfiguration({ schoolId: this.examInfo.schoolId, subjectCode: this.examInfo.subjectCode })
      if (res.success) {
        const sixRateList = []
        res.body.filter(s => s.show).forEach(item => {
          item.show = false
          sixRateList.push(item)
        })

        list.push(...util.deepCopy(sixRateList))
        list.forEach(item => {
          item.show = item.name.includes('平均分')
        })

        targetList.push(...util.deepCopy(sixRateList))
        targetList.push({
          "name": "排名",
          "show": false,
          "value": "averageRanking"
        })

        subTargetList.push(...util.deepCopy(sixRateList))
      }

      this.basicIndicatorsTarget = targetList
      this.basicIndicatorsHistogramTarget = list
      this.checkedBasicIndicators = targetList.filter(s => s.show).map(s => s.value)
      this.basicSubIndicatorsTarget = subTargetList
      this.checkedSubBasicIndicators = subTargetList.filter(s => s.show).map(s => s.value)

    },
    // 查询年级各班总分基础指标分析
    async getMultipleBasicIndicators () {
      let params = {
        schoolId: this.schoolId,
        finalExamId: this.examId,
      }
      this.compareTableGradeData = {}
      this.quotaLoading = true;
      let resp = await reportApi.getMultipleBasicIndicators(params);
      this.quotaLoading = false;
      if (resp.success) {
        this.quotaList = resp.body
        for (let item of this.quotaList) {
          item.maxScore = isNaN(item.maxScore) ? '--' : parseFloat(item.maxScore)
          item.minScore = isNaN(item.minScore) ? '--' : parseFloat(item.minScore)
          item.averageScore = isNaN(item.averageScore) ? '--' : parseFloat(item.averageScore)
          item.wonderRate = isNaN(parseFloat(item.wonderRate)) ? '--' : parseFloat(item.wonderRate)
          item.excelRate = isNaN(parseFloat(item.excelRate)) ? '--' : parseFloat(item.excelRate)
          item.goodRate = isNaN(parseFloat(item.goodRate)) ? '--' : parseFloat(item.goodRate)
          item.passRate = isNaN(parseFloat(item.passRate)) ? '--' : parseFloat(item.passRate)
          item.tiredRate = isNaN(parseFloat(item.tiredRate)) ? '--' : parseFloat(item.tiredRate)
          item.feebleRate = isNaN(parseFloat(item.feebleRate)) ? '--' : parseFloat(item.feebleRate)
          item.deviation = isNaN(item.deviation) ? '--' : parseFloat(item.deviation)
        }
        this.compareTableGradeData = resp.body.find(item => item.classId === '' && item.className === '年级')
        this.initCompareImgData()
        this.$nextTick(() => {
          if (this.$refs.multiSelect) {
            this.$refs.multiSelect.setAll()
          }
        })
      } else {
        this.$message.warning(resp.message)
      }
    },
    initCompareImgData () {
      this.compareData = this.quotaList.filter((item) => item.classId === '' || this.checkedSchoolClasses.some(c => c == item.classId))
      this.compareImgData = this.quotaList.filter((item) => item.classId !== '' && this.checkedSchoolClasses.some(c => c == item.classId))
      this.compareDataPart = this.compareData
    },
    iniCompareImgData () {
      const list = this.basicIndicatorsHistogramTarget.filter(s => s.show)
      this.basicIndicatorsLoading = true
      let option = {};
      option.legendData = [];
      option.legend = list.map(s => s.name)
      option.xAxisData = [];
      option.yAxisData = [];
      option.data = [];
      option.series = [];

      // Y轴数据
      const isIncludePoint = list.some(s => s.value.includes('Score'))
      const isIncludeRate = list.some(s => s.value.includes('Rate'))

      if (isIncludePoint) {
        option.yAxisData.push({
          type: 'value',
          name: '',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#718EBF'
            }
          },
          axisLabel: {
            formatter: '{value}分'
          },
          splitLine: {
            show: true, // 显示分割线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: "#DFE5EE"
            }
          }
        })
      }
      if (isIncludeRate) {
        option.yAxisData.push({
          type: 'value',
          name: '',
          position: 'right',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#718EBF'
            }
          },
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            show: true, // 显示分割线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: "#DFE5EE"
            }
          }
        })
      }

      const seriesList = []
      let gradeAvgLine = {}
      if (this.compareTableGradeData && this.compareTableGradeData.averageScore) {
        gradeAvgLine = {
          lineStyle: {
            color: '#FFB660'
          },
          symbol: 'none', // 取消两侧箭头
          data: [
            {
              yAxis: this.compareTableGradeData.averageScore,
              label: {
                show: true,
                position: 'middle',
                formatter: '平均值: ' + this.compareTableGradeData.averageScore,
              }
            }
          ]
        }
      }

      list.forEach(item => {
        let series = {
          name: item.name,
          key: item.value,
          type: 'bar',
          data: [],
        }
        if (item.value === 'averageScore') {
          series.markLine = gradeAvgLine
        }

        if (option.yAxisData.length > 1 && item.value.includes('Rate')) {
          series.yAxisIndex = 1
        }

        seriesList.push(series)
      })

      if (option.yAxisData.length > 0) {
        const compareImgData = util.sortArrayByKey(util.deepCopy(this.compareImgData), 'className')
        // 增加X轴 班级名称 TODO:增加排序
        compareImgData.forEach(item => {
          option.xAxisData.push(item.className);
          seriesList.forEach(series => {
            series.data.push(
              parseFloat(item[series.key])
            );
          })
        })
      }

      option.series = seriesList
      this.$nextTick(() => {
        multipleYEchartBar(option, 'basicIndicators')
        this.basicIndicatorsLoading = false
      });
    },
    // 修改基础指标柱状图指标
    changeTarget (target) {
      const list = this.basicIndicatorsHistogramTarget.filter(s => s.show)
      if (target.show && list.length <= 1) {
        this.$message.warning('至少选择一个指标')
        return
      }
      if (!target.show && list.length >= 3) {
        this.$message.warning('最多选择三个指标')
        return
      }

      target.show = !target.show
      this.iniCompareImgData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.className == '年级') {
        return 'grade-row'
      } else if (row.className == '联考' || row.className == '全区') {
        return 'school-row'
      } else {
        return ''
      }
    },

    handleCheckedSchoolClassChange (val) {
      this.checkedSchoolClasses = val
      this.initCompareImgData()
      this.iniCompareImgData()
    },
    handleCheckedBasicIndicatorsChange (val) {
      this.basicIndicatorsTarget.forEach(item => {
        item.show = this.checkedBasicIndicators.some(s => s === item.value)
      })
    },
    handleCheckedSubBasicIndicatorsChange (val) {
      this.basicSubIndicatorsTarget.forEach(item => {
        item.show = this.checkedSubBasicIndicators.some(s => s === item.value)
      })
    },
    // 导出基础指标
    exportBasicIndicators (id) {
      if (id === 'basicIndicators' && this.exportLoading || (util.isEmpty(id) && this.exportSubLoading)) {
        return
      }

      // 图形导出
      if (this.basicIndicatorsHistogram && id === 'basicIndicators') {
        exportChart(id, `${this.gradeName}各班基础指标对比分析`)
        this.exportLoading = false
      } else {
        if (util.isEmpty(id)) {
          this.checkSubTaskCount = 0
          this.exportSubLoading = true
        } else {
          this.checkTaskCount = 0
          this.exportLoading = true
        }
        // 表格导出
        const params = this.getReportExportParams(id)
        reportApi.startExportTask(params).then(resp => {
          if (resp.success) {
            let params = {
              examId: this.examId,
              schoolId: this.schoolId,
              types: [this.getReportExportType(id)]
            }
            this.checkExportTask(params, id)
          } else {
            this.$message.warning(resp.message)
          }
        })
      }
    },

    checkExportTask (params, id) {
      reportApi.checkExportTask(params).then(resp => {
        if (resp.body && resp.body.length) {
          const task = resp.body[0]
          if (task.state + '' === '2' && task.url) {
            this.closeLoading(id)
            window.open(task.url)
          } else {
            let count = util.isEmpty(id) ? this.checkSubTaskCount : this.checkTaskCount
            if (count < 10) {
              count++
              setTimeout(() => {
                this.checkExportTask(params, id)
              }, 5 * 1000);
            } else {
              this.closeLoading(id)
              this.$message.warning('导出数据太多，请稍后尝试！')
            }
          }
        } else {
          this.closeLoading(id)
          this.$message.warning(resp.message || '下载失败，请重新尝试！')
        }
      })
    },
    closeLoading (id) {
      if (util.isEmpty(id)) {
        this.exportSubLoading = false
        this.checkSubTaskCount = 0
      } else {
        this.checkTaskCount = 0
        this.exportLoading = false
      }
    },
    // 获取年级报告导出文件参数
    getReportExportParams (id) {
      let ranking = {}
      let list = []
      let checkedSchoolClasses = []
      if (id === 'basicIndicators') {
        ranking = this.basicIndicatorsTarget.find(s => s.name === '排名');
        list = this.basicIndicatorsTarget.filter(s => s.name !== '排名' && s.show);
        checkedSchoolClasses = this.checkedSchoolClasses
      } else {
        list = this.basicSubIndicatorsTarget.filter(s => s.name !== '排名' && s.show);
      }

      const param = {
        examId: this.examId,
        schoolId: this.schoolId,
        module: "REPORT",
        paramModel: {
          examId: this.examId,
          schoolId: this.schoolId,
          type: this.getReportExportType(id),
          "async": true,
          includeProperties: list, // 选中指标数据
          changeParam: checkedSchoolClasses ? checkedSchoolClasses.join(',') : [], // 选中班级信息
          showRank: ranking && ranking.show, // 是否排名
        }
      }
      if (id == 'basicIndicators' && this.indicatorsSortInfo && this.indicatorsSortInfo.order) {
        param.paramModel.orderBy = this.indicatorsSortInfo.name
        param.paramModel.orderByDesc = this.indicatorsSortInfo.order === 'descending'
      } else if (this.subIndicatorsSortInfo && this.subIndicatorsSortInfo.order) {
        param.paramModel.orderBy = this.subIndicatorsSortInfo.name
        param.paramModel.orderByDesc = this.subIndicatorsSortInfo.order === 'descending'
      }

      return param
    },
    // 获取导出类型
    getReportExportType (id) {
      if (id === 'basicIndicators') {
        return 'SCHOOL_MULTIPLE_ALL_CLASS_BASIC_INDEX';
      } else {
        return 'SCHOOL_MULTIPLE_ALL_SUBJECT_BASIC_INDEX'
      }
    }
  },

  watch: {
    branch () {
      this._initFunc()
    },
    classId (val) {
      this._classMultiRanking();
    },

    // 初始化优劣势学科图形(雷达图)
    classRankingData (val) {
      if (!val || val.length <= 0) {
        return
      }
      const param = {
        indicator: [],
        gradeSeriesValue: []
      }
      for (let item of val) {
        param.indicator.push({
          name: item.subjectName + " (" + item.ratio + ")",
          max: 100
        });
        param.gradeSeriesValue.push(item.ratio.replace("%", ""));
      }
      let options = {
        // backgroundColor: '#f8f8f8',
        tooltip: {
          formatter: function (resp) {
            let res = "";
            for (let item of val) {
              res += `<p>${item.subjectName} : <em style="padding-left: 10px;color: #fabb0a">${item.ratio}</em></p>`;
            }
            return res;
          }
        },
        radar: {
          name: {
            textStyle: {
              color: "#94a5bc",
              fontSize: 12
            }
          },
          splitNumber: 3,
          indicator: param.indicator,
          axisLine: {
            // (圆内的几条直线)坐标轴轴线相关设置
            lineStyle: {
              color: "#eff3f9" // 坐标轴线线的颜色。
            }
          },
          splitLine: {
            // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: "#eff3f9" // 分隔线颜色
            }
          },
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: {
              color: ["#b9f3f4", "#daf8f8", "#f2fcfd"] // 图表背景网格的颜色
            }
          }
        },
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 8,
            data: [
              {
                value: param.gradeSeriesValue,
                name: "学科",
                itemStyle: {
                  normal: {
                    color: "#fabb0a"
                  }
                }
              }
            ]
          }
        ]
      };

      let radarChart = echarts.init(document.getElementById("subjectRadar"));
      this.$nextTick(() => {
        radarChart.setOption(options);
      });
    }
  },
  components: {
    MultiSelect
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  flex: 1;
  width: 0;
  box-sizing: border-box;
  margin-top: 14px;

  .last-card {
    display: flex;
    .card {
      flex: 1;
      h3 {
        height: 60px;
        line-height: 60px;
        .el-button-group .el-button--primary:first-child {
          border-radius: 20px 0 0 20px;
          border-right-color: $color-theme;
        }
        .el-button-group .el-button--primary:last-child {
          border-radius: 0 20px 20px 0;
          border-left-color: $color-theme;
        }
        .el-button-group .el-button:not(:last-child) {
          margin: 0;
        }
      }
    }
  }

  .card {
    flex: 1;
    border-radius: 4px;
    background: #fff;
    box-shadow: $box-shadow;
    padding-bottom: 10px;
    margin-bottom: 20px;
    > h3 {
      padding: 0 10px;
      height: 40px;
      line-height: 44px;
      font-size: 16px;
      color: $color-text;
      &:before {
        margin-top: -4px;
        display: inline-block;
        content: "";
        width: 4px;
        height: 20px;
        vertical-align: middle;
        background: $color-theme;
        border-radius: 10px;
        margin-right: 10px;
      }
      span {
        padding-left: 20px;
        font-size: $font-size-small;
        color: #aaa;
      }

      .button-group {
        display: inline-block;
        float: right;
      }
    }
    .header-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h3 {
        margin: 32px 0 32px 32px;
        height: 40px;
        line-height: 44px;
        font-size: 16px;
        color: $color-text;
        &:before {
          margin-top: -4px;
          display: inline-block;
          content: "";
          width: 4px;
          height: 20px;
          vertical-align: middle;
          background: $color-theme;
          border-radius: 10px;
          margin-right: 10px;
        }
        span {
          padding-left: 20px;
          font-size: $font-size-small;
          color: #aaa;
        }
        .button-group {
          display: inline-block;
          float: right;
        }
      }

      .header-center {
        .el-button-group {
          .el-button {
            margin: 0 15px;
            cursor: pointer;
            color: #333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 14px;
            border-radius: 0;
          }
          .el-button.active {
            color: #2877ff;
            border-bottom: 2px solid #2877ff;
          }
        }
      }

      .header-right {
        display: flex;
        width: 40%;
        justify-content: flex-end;
        align-items: center;
        margin-right: 32px;
        .el-button {
          background-color: white;
          margin-right: 15px;
        }

        .text {
          color: #2877ff;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          margin-right: 5px;
          margin-left: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
          width: 60px;
        }
      }
    }

    .card-table {
      padding: 10px 15px;
      box-sizing: border-box;
    }
    .analysis-wrapper {
      display: flex;
      padding: 20px 35px;
      > li {
        &:nth-child(1) {
          background: #f8bb46;
        }
        &:nth-child(2) {
          background: #2393eb;
        }
        &:nth-child(3) {
          background: #71d376;
        }
        &:nth-child(4) {
          background: #bcaaa4;
        }
        flex: 1;
        width: 210px;
        margin: 0 12px;
        padding: 6px;
        box-sizing: border-box;
        > h5 {
          color: #fff;
          font-size: 18px;
          height: 30px;
          line-height: 30px;
          text-align: center;
        }
        > p {
          color: #fff;
          font-size: 36px;
          font-weight: bold;
          height: 56px;
          line-height: 56px;
          text-align: center;
        }
        > ul {
          background: #fff;
          padding: 6px 12px;
          > li {
            &:last-child {
              border-top: 1px solid #f5f5f5;
              padding: 6px 0;
            }
            height: 38px;
            line-height: 38px;
            display: flex;
            > span {
              flex: 1;
            }
            img {
              vertical-align: middle;
              margin-top: 8px;
              padding: 0 8px;
            }
            label {
              font-weight: bold;
              color: $color-text;
            }
          }
        }
      }
    }
    #scoreLine {
      width: 100%;
      height: 280px;
      padding: 0 40px;
      box-sizing: border-box;
    }
    .card-content {
      padding: 0 32px;
      .pie-title {
        margin-top: 10px;
        display: inline-block;
        background: $color-theme;
        color: #fff;
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 2px;
      }

      .title-bg {
        height: 40px;
        background: #e8f0ff;
        display: flex;
        align-items: center;
        width: max-content;
        border-radius: 4px;
        width: 100%;
        justify-content: center;

        span {
          color: rgba(52, 60, 106, 0.5);
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          cursor: pointer;
          padding: 6px;
          margin: 0 15px;
          max-width: 120px; /* 设置容器宽度 */
          white-space: nowrap; /* 禁止文本换行 */
          overflow: hidden; /* 隐藏超出容器的文本 */
          text-overflow: ellipsis;
          flex: 1;
          text-align: center;
        }
        span:hover,
        span.active {
          background: #2877ff;
          color: white;
          border-radius: 4px;
        }
      }

      #basicIndicators {
        width: 100%;
        height: 400px;
      }
    }
    .card-three {
      display: flex;
      padding: 20px 35px;
      height: 280px;
      justify-content: center;
      align-items: center;
      .tip-wrapper {
        padding: 15px 10px;
        width: 400px;
        height: 80px;
        display: flex;
        background: #f8f9fb;
        > img {
          margin-right: 10px;
        }
        .tip {
          flex: 1;
          > p {
            height: 26px;
            line-height: 26px;
            color: #9f9f9f;
            font-size: 15px;
            > span {
              color: #f4903f;
              padding: 0 3px;
            }
          }
        }
      }
      #subjectRadar {
        flex: 1;
        width: 500px;
        height: 270px;
      }
    }

    .card-four {
      display: flex;
      padding: 20px 35px;
      height: 280px;
      .card-left {
        flex: 1;
      }
      .card-right {
        flex: 1;
      }
    }
    .card-five {
      display: flex;
      padding: 20px 35px;
      height: 280px;
      .card-left {
        flex: 1;
      }
      .card-right {
        flex: 1;
      }
    }
  }
  .advantage {
    .head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        padding: 0 10px;
        height: 40px;
        line-height: 44px;
        font-size: 16px;
        color: $color-text;
        &:before {
          margin-top: -4px;
          display: inline-block;
          content: "";
          width: 4px;
          height: 20px;
          vertical-align: middle;
          background: $color-theme;
          border-radius: 10px;
          margin-right: 10px;
        }
        span {
          padding-left: 20px;
          font-size: $font-size-small;
          color: #aaa;
        }

        .button-group {
          display: inline-block;
          float: right;
        }
      }
      .select-round {
        padding: 10px;
      }
    }
  }
}

.dialog-setting {
  margin: 0 60px;
  .setting-header {
    font-size: 16px;
    display: flex;
    position: relative;
    > div {
      cursor: pointer;
      flex: 1;
      height: 40px;
      line-height: 30px;
      text-align: center;
      &:hover {
        color: $color-theme;
      }
    }
    > hr {
      transition: transform 0.2s;
      position: absolute;
      left: 85px;
      bottom: 0;
      width: 140px;
      height: 3px;
      border: none;
      background: $color-theme;
    }
  }
  .setting-content {
    .score {
      .score-header {
        padding: 10px 0 20px;
        .el-select {
          width: 140px;
        }
        > span {
          margin-left: 20px;
          display: inline-block;
        }
      }
      .el-input__inner {
        text-align: center;
      }
    }
    .count {
      height: 505px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

//高亮最高最低数据
.lightHigh {
  color: $middle-blue;
}
.lightLow {
  color: $color-red;
}
#fourSectionAnalysis {
  width: 100%;
  height: 270px;
}

.basic-select {
  width: 210px;
  margin: 0 16px;
  cursor: pointer;
}
</style>

<style lang="scss">
.basic-popover {
  border: 1px solid #2877ff;
  filter: drop-shadow(0px 3px 5px rgba(80, 152, 248, 0.2));

  .el-checkbox {
    margin: 6px 0;
  }

  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }

  .school-class {
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-items: center;
  }

  .el-checkbox__label {
    width: 70px;
    white-space: nowrap; /* 防止文字换行 */
    overflow: hidden; /* 隐藏超出的部分 */
    text-overflow: ellipsis; /* 显示省略号 */
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
}
</style>